const apiKeys = ["AIzaSyAZ3mo1WAGzvChL_eWGmelBYgc-EXAL7Rg", "AIzaSyDWYzXFWIP-7bKA24gsU3XaiuEcM9BFYis"];

type Libraries = ("drawing" | "geometry" | "localContext" | "places" | "visualization")[];

const constantApiKey = () => {
    const today = new Date();

    const x = today.getMinutes() % 3;
    switch (Math.round(x)) {
        case 0:
            return apiKeys[0];

        case 1:
            return apiKeys[1];

        default:
            return apiKeys[1];
    }
};

const apiKey = constantApiKey();

export const libraries: Libraries = ["places"];

export const getApiKey = () => {
    return apiKey;
};

export const getLibraries = () => {
    return libraries;
};
